<template>
  <div :class="['element-input-label']">
    <label :class="['label-text', required ? 'required' : '']">{{ text }}</label>
  </div>
</template>

<script>
  export default {
    name: "InputLabel",
    props: {
      // 标签文本
      text: {
        type: String
      },
      // 是否必填
      required: {
        type: Boolean
      }
    },
    data() {
      return {};
    }
  };
</script>

<style lang='less' scoped>
  @import "./config/index";
  .element-input-label {
    display: inline-block;
    font-size: @label-size;
    color: @label-color;
    margin-right: @label-mr;
  }
</style>
